import { createActions } from '../utils/actions';

import studioPhoto from './studio.photo';
import studioVideo from './studio.video';

const { actions: studio } = createActions('studio')
  .add('bootstrap')
  .add('cleanUp');

studio.photo = studioPhoto;
studio.video = studioVideo;

export default studio;
